import React from 'react';
// import { FormGroup, Input, FormFeedback, Label} from 'reactstrap'
import {connect} from 'react-redux'; 
import StringInput from "../StringInput"
import * as actions from "store/actions/colors"
import validation from '../../validation';
import * as yup from 'yup';
import ImageInput from '../ImageInput';

class VerticalWithShadowImageInput extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            name: "vertical_with_shadow",
            invalid: false
        }
        this.handleChange = this.handleChange.bind(this);
        this.verticalWithShadowFileRef = React.createRef();
    }

    componentDidMount(){
   
    }

    handleChange(file){
        this.props.actions.change(this.state.name, file)
    }

    
    render(){
        return(
            <React.Fragment>
                <ImageInput
                    title={"Imagem vertical para o Mood"}
                    fileRef={this.verticalWithShadowFileRef}
                    onChange={this.handleChange}
                    inputId={this.state.name}
                    url={this.props.image.url}>
                </ImageInput>
            </React.Fragment>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        image: state.colors.images.vertical_with_shadow,
        error: state.colors.errors.vertical_with_shadow
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions:{
            setError: (name, value) => {
                return dispatch({
                    type: actions.SET_ERROR,
                    payload: {
                        name: name,
                        value: value
                    }
                })
            },
            change: (name, value) => {
                return dispatch({
                    type: actions.SET_IMAGE,
                    payload: {
                        name: name,
                        value: value
                    }
                })
            }
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(VerticalWithShadowImageInput);